import React from "react";
import { ButtonSelector, formatterFunction } from "app/interaction/ButtonSelector/ButtonSelector";
import { chartPeriods } from "app/charts/types";

import "./style.scss";

const periods = {
    Intraday: "1 Tag",
    OneMonth: "1 Monat",
    OneYear: "1 Jahr",
    ThreeYears: "3 Jahre",
    FiveYears: "5 Jahre"
};

const periodsWithoutIntraday = Object.assign({}, periods);
delete (periodsWithoutIntraday as any).Intraday;

interface Props {
    value: chartPeriods;
    onChange?: React.Dispatch<chartPeriods>;
    noIntraday?: boolean;
}

const labelFormatter: formatterFunction = label => (
    <React.Fragment>
        {label.substr(0, 3)}
        <span>{label.substr(3)}</span>
    </React.Fragment>
);

export const PeriodSelector = ({ value, onChange, noIntraday }: Props) => (
    <ButtonSelector
        className="periodSelector"
        value={value}
        onChange={nextValue => onChange && onChange(nextValue as chartPeriods)}
        items={noIntraday ? periodsWithoutIntraday : periods}
        labelFormatter={labelFormatter}
    />
);
